import { getUsersByPageSize } from './mockdata/user';

export default {
    'post /mock/login': (config) => {
        console.log('config:'+JSON.stringify(config.data));
        const {
            name,
            password,
        } = JSON.parse(config.data);
        return new Promise((resolve, reject) => {
            if (name !== 'admin' || password !== '111') {
                setTimeout(() => {
                    reject({
                        code: 1001,
                        message: '用户名amdin或密码错误111',
                    });
                }, 1000);
            } else {
                setTimeout(() => {
                    resolve([200, {
                        "Code":0,
                        "Err":"",
                        "Data":"7375646f050f90e10f634ce3ec7b11aa511379fd"
                    }]);
                }, 1000);
            }
        });
    },
    'post /mock/logout': {},

    'get /mock/users': (config) => {
        const {
            pageSize,
            pageNum,
        } = config.params;


        return new Promise((resolve) => {
            setTimeout(() => {
                resolve([200, {
                    pageNum,
                    pageSize,
                    total: 888,
                    list: getUsersByPageSize(pageSize),
                }]);
            }, 1000);
        });
    },
    'get re:/mock/users/.+': { id: 1, name: '熊大', age: 22, job: 0, position: '1' },
    'post /mock/users': true,
    'put /mock/users': true,
    'delete /mock/users': true,
    'delete re:/mock/users/.+': true,
};
